import { ModuleSettingField } from '../../../Utilities/Enums/ParametersEnum';
import { ActiveStatusEnum } from '../../../Utilities/Enums/StatusEnums';

export class ModuleSetting {
    [ModuleSettingField.PUBLIC_ID]?: string | number = "";
    [ModuleSettingField.NAME]?: string = "";
    [ModuleSettingField.DESCRIPTION]?: string = "";
    [ModuleSettingField.STATUS]: ActiveStatusEnum = ActiveStatusEnum.ACTIVE;
    [ModuleSettingField.UPDATED_DATE]?: string | Date | null = null;

    constructor(obj?: Partial<ModuleSetting>) {
        Object.assign(this, obj);
    }
}

export class AddEditModuleModalInterface {
    openAddEditModal?: boolean;
    setopenAddEditModal?: React.Dispatch<React.SetStateAction<boolean>>;
    selectedModule?: ModuleSetting;
    setselectedModule?: React.Dispatch<React.SetStateAction<ModuleSetting>>;

    constructor(obj?: Partial<AddEditModuleModalInterface>) {
        Object.assign(this, obj);
    }
}